import { MEMBER_ERRORS } from "../member/member-errors.js";
import { USER_ERRORS } from "../user/user-errors.js";

export const COMMUNITY_ERRORS = {
	INVALID_SLUG: "invalid_slug",
	NOT_FOUND: "community_not_found",
	USER_NOT_FOUND: USER_ERRORS.NOT_FOUND,
	MEMBER_NOT_FOUND: MEMBER_ERRORS.NOT_FOUND,
	UNAUTHORIZED_OWNER_ONLY: "unauthorized_owner_only",
	SLUG_ALREADY_TAKEN: "slug_already_taken",
	ROLE_CHANGE_NOT_ALLOWED: "role_change_not_allowed",
	CANNOT_CHANGE_OWN_ROLE: "cannot_change_own_role",
} as const;

export type CommunityErrorCode = (typeof COMMUNITY_ERRORS)[keyof typeof COMMUNITY_ERRORS];
